import axios from "axios";
import { gapi } from "./api.js";
import str from '../index.js'
import std from './students.js'
const url = gapi + "payments";


const income = {
  namespaced: true,
  state: {
    msg:null,
    payAll: [],
    students:[],
    accountType:[],
    payType:[]  
  },
  getters: {
    GET_ALLDATA: (state) => {
      return state.payAll;
    },
    getTodoById: (state) => (id) => {
      return state.payAll.find((todo) => todo.id == id);
    },
    getMsg: (state) => {
      return state.msg;
    }
  },
  mutations: {
    SET_DATA(state, data) {
      state.payAll = data;
    },

    ADD_DATA(state, data) {
      this.students = std.state.stdAll.find((todo) => todo.id == data.stdID);
      this.accountName = str.state.accountType.find((todo) => todo.id == data.accType);
      var toaccount = str.state.accountType.find((todo) => todo.id == data.ToAccount);
      this.payType = str.state.payType.find((todo) => todo.id == data.payType);
      data.accountName = this.accountName.accountName;
      data.pType = this.payType.pType;
      data.ToAccountName = toaccount;
      data.fullName = this.students.Fname + ' '+this.students.Ffname;
      state.payAll.unshift(data);
    },
  
    UPDATE_DATA(state, data) { 
      const index = state.payAll.findIndex((t) => t.id === data.id);
      this.students = std.state.stdAll.find((todo) => todo.id == data.stdID);
      this.accountName = str.state.accountType.find((todo) => todo.id == data.accType);
      this.payType = str.state.payType.find((todo) => todo.id == data.payType);
      var toaccount = str.state.accountType.find((todo) => todo.id == data.accType);

      data.fullName = this.students.Fname + ' '+this.students.Ffname;
      var dts = {
        id : data.id ,
        payName : data.payName ,
        payDate : data.payDate ,
        accType: data.accType,
        stdID : data.stdID ,
        Details : data.Details ,
        busID : data.busID ,
        payType : data.payType ,
        amount : data.amount ,
        check : data.check ,
        fullName : data.fullName, 
        ToAccount : toaccount, 
        accountName : this.accountName.accountName,
        pType : this.payType.pType
              
                     }
      if (index !== -1) {
        state.payAll.splice(index, 1, dts);
      }
    },
    DELETE_DATA(state, data) {
      state.payAll = state.payAll.filter((t) => data.id !== t.id);
    },STATE_CRUD(state,data){
      var num = data;
      num = num.toString().replace( /^\D+/g, '');
      state.msg = num;
    }
  }
  ,
  actions: {

    async fetchData({ commit }) {
      await axios
        .get(url,{headers:{Authorization: str.state.token}})
        .then((res) => {
          commit("SET_DATA", res.data.data);
          // console.log(res.data.data)
        })
        .catch((error) => console.log(error));
    }, // get all data view with reletion
  
    // add student
    async addData({ commit }, data) {
      await axios
        .post(url, data,{headers:{Authorization: str.state.token}})
        .then((res) => {
          commit("ADD_DATA", res.data.data);
          return res
        })
        .catch((error) => {
        console.log(error)
        return error
      });
    },
    // get student to edit
    async getData(id) {
      await axios
        .get(url + "/" + id,{headers:{Authorization: str.state.token}})
        .then((res) => {
          return res.data.data;

        })
        .catch((error) => console.log(error));
    },
    // update student
   async  updateData({ commit }, data) {

      var app = url + "/" + data.id;
      await axios
        .put(app, data,{headers:{Authorization: str.state.token}})
        .then((res)=>{
         
          commit("UPDATE_DATA", data)
          commit("STATE_CRUD", res.data.status)
        
        })
        .catch((error) =>{ console.log(error)
         
         
          commit("STATE_CRUD", error)
      });
    
    },

    async deleteData({ commit }, data) {
      var app = url + "/" + data.id;
      await axios
        .delete(app,{headers:{Authorization: str.state.token}})
        .then(
          commit("DELETE_DATA", data)
 
        )
        .catch((error) => console.log(error));
    },
  },
};
export default income;
